import styled from 'styled-components';

const BRAND_ORANGE = '#FF6B00';
const AVATAR_SIZE = '32px';

/**
 * Full-width fixed header bar.
 * z-index 998 and box-shadow mirror `.navbar-bottom` in navigationbar.css.
 */
export const HeaderBar = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  height: 60px;
  padding: 0 16px;
  z-index: 998;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);
  gap: 12px;
`;

export const LogoArea = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

export const SearchArea = styled.div`
  display: flex;
  align-items: center;
  flex: 0 0 200px;
`;

export const NavArea = styled.nav`
  display: flex;
  align-items: center;
  gap: 2px;
  flex: 1;
`;

export const StatusArea = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
`;

export const UserArea = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

/**
 * Button-reset trigger for each nav group dropdown.
 * When className="active" is applied, an orange bottom border appears.
 */
export const NavGroupTrigger = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0 10px;
  height: 60px;
  font-size: 14px;
  color: #333333;
  border-bottom: 3px solid transparent;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;

  &:focus {
    outline: none;
  }

  &:hover {
    color: ${BRAND_ORANGE};
  }

  &.active {
    border-bottom: 3px solid ${BRAND_ORANGE};
    color: ${BRAND_ORANGE};
    font-weight: 600;
  }
`;

/**
 * Circular avatar showing user initials.
 * Orange background (#FF6B00), white text, ~32px diameter.
 */
export const AvatarCircle = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${AVATAR_SIZE};
  height: ${AVATAR_SIZE};
  border-radius: 50%;
  background-color: ${BRAND_ORANGE};
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  flex-shrink: 0;
  user-select: none;
`;

/**
 * Rounded status pill: light green background, green dot, small font.
 */
export const SystemPill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background-color: #e6f9f0;
  color: #1a7a4a;
  font-size: 11px;
  font-weight: 500;
  padding: 3px 8px;
  border-radius: 12px;
  white-space: nowrap;

  .system-pill-dot {
    color: #22c55e;
    font-size: 10px;
    line-height: 1;
  }
`;
